/* global axios */
import ApiClient from './ApiClient';

class InboxHealthAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getHealthStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/health`);
  }

  getCampaignHealth(inboxId, params = {}) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_campaign_health`, {
      params,
    });
  }
}

export default new InboxHealthAPI();
